import React, { useEffect, useState, useRef } from 'react';
import '../css/button.css';
import { useNavigate, useParams } from 'react-router-dom';
import anime, { set } from 'animejs';
import HomeButton from '../utils/HomeButton';

const Madagascar = (props) => {

    const [page, setPage] = useState(0);

    const [langue, setLangue] = useState('en');
    const langueRef = useRef(langue);
    const param = useParams();

    const [currentSubtitle, setCurrentSubtitle] = useState("")

    const handleMenuClick = (page) => {
        let url;
        switch (page) {
            case 1:
                url = '/madagascar/';
                break;
            case 2:
                url = '/madagascar/2-sensors';
                break;
            case 3:
                url = '/madagascar/3-rattle';
                break;
            case 4:
                url = '/madagascar/4-slowdown';
                break;
            case 5:
                url = '/madagascar/5-variation';
                break;
            case 6:
                url = '/madagascar/6-duo';
                break;
            case 7:
                url = '/madagascar/7-photo';
                break;
            case 8:
                url = '/madagascar/8-justinvali';
                break;
            case 9:
                url = '/madagascar/9-comment';
                break;
            default:
                url = '/madagascar/';
        }
        //navigate(url);
        window.parent.location.href = 'https://digitaljazz.fr/clesdecoute' + url;
    };

    const [showMenu, setShowMenu] = useState(false);

    const navigate = useNavigate();
    console.log(param.page);

    const switchLangue = () => {
        if (langue === 'en') {
            setLangue('fr');
            langueRef.current = 'fr';
        } else {
            setLangue('en');
            langueRef.current = 'en';
        }
    }

    useEffect(() => {
        const intervalId = setInterval(() => {
            if(document.getElementById('videoWithSubtitles') == null) return;
            const videoElement = document.getElementById('videoWithSubtitles');
            const videoTime = videoElement.currentTime;

            if (videoTime >= 0 && videoTime < 6) {
                setCurrentSubtitle(langueRef.current === 'en' ? "I'm going to work hard on this one." : "Je vais travailler à fond celui-là.");
            } else if (videoTime >= 6 && videoTime < 17) {
                setCurrentSubtitle(langueRef.current === 'en' ? "For me, it's not obvious, nor for all citharists." : "Pour moi, ce n'est pas évident, ni pour tous les citharistes.");
            } else if (videoTime >= 17 && videoTime < 27) {
                setCurrentSubtitle(langueRef.current === 'en' ? "Even Vezo players [south-west of the country], for example Bekamby [deceased Vezo], they don't play as fast as Velonjoro." : "Même des joueurs vezo [Sud-Ouest du pays], par exemple Bekamby [Vezo décédé], ils ne jouent pas aussi vite que Velonjoro.");
            } else if (videoTime >= 27 && videoTime < 43) {
                setCurrentSubtitle(langueRef.current === 'en' ? "Besides, it's my challenge. While we're not yet completely old I want to exploit speed." : "En plus, c'est mon défi. Pendant qu'on n'est pas encore vieux complètement, j'ai envie d'exploiter la rapidité.");
            } else if (videoTime >= 43 && videoTime < 53) {
                setCurrentSubtitle(langueRef.current === 'en' ? "Sometimes, when I'm in there, it goes by itself." : "Quelque fois, quand je suis là-dedans, ça va tout seul.");
            } else if (videoTime >= 53 && videoTime < 59) {
                setCurrentSubtitle(langueRef.current === 'en' ? "But as soon as I start thinking, I'm lost." : "Mais dès que je commence à réfléchir, je suis perdu.");
            } else if (videoTime >= 59 && videoTime < 70) {
                setCurrentSubtitle(langueRef.current === 'en' ? "When he plays, in the photos it looks like he's laughing, he's like a machine." : "Lui quand il joue, sur les photos on dirait qu'il rigole, c'est comme une machine.");
            } else if (videoTime >= 70 && videoTime < 78) {
                setCurrentSubtitle("");
            } else if (videoTime >= 78 && videoTime < 98) {
                setCurrentSubtitle(langueRef.current === 'en' ? "Maybe I need to ask his [Velonjoro's] spirit to help me a little bit with his piece because it's great." : "Peut-être qu'il faut que je demande à son esprit [de Velonjoro] pour qu'il m'aide un petit peu à faire son morceau parce que c'est génial.");
            }
            //If video is paused, no subtitle
            if (videoElement.paused) setCurrentSubtitle("");
        }, 250); // update the videoTime state every second

        return () => clearInterval(intervalId); // clear the interval when the component unmounts
    }, []);

    useEffect(() => {
        let pageNumber;

        switch (param.page) {
            case '':
                pageNumber = 1;
                break;
            case '2-sensors':
                pageNumber = 2;
                break;
            case '3-rattle':
                pageNumber = 3;
                break;
            case '4-slowdown':
                pageNumber = 4;
                break;
            case '5-variation':
                pageNumber = 5;
                break;
            case '6-duo':
                pageNumber = 6;
                break;
            case '7-photo':
                pageNumber = 7;
                break;
            case '8-justinvali':
                pageNumber = 8;
                break;
            case '9-comment':
                pageNumber = 9;
                break;
            default:
                pageNumber = 0;
        }
        setPage(pageNumber);
        console.log("page is now : " + pageNumber);

        if (pageNumber === 0) {
            //navigate(process.env.PUBLIC_URL + '/madagascar//');
            handleMenuClick(1);
            setPage(1);
        }

    }, [param.page]);

    return (
        <>
            <div
                className='background'
                style={{
                    backgroundColor: '#28100D',
                }}
            />
            <HomeButton />
            {/* page 1 */}
            {page === 1 &&
                <>
                    <video
                        style={{
                            position: 'absolute',
                            top: '30px',
                            left: '90px',
                            width: '480px',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/movies/mad1.mp4'}
                        controls
                    />
                    <div
                        className='text'
                        style={{
                            position: 'absolute',
                            top: '400px',
                            width: '614px',
                            left: '20px',
                            color: 'white',
                            fontSize: '16px',
                            fontFamily: 'Futura',
                            cursor: 'pointer',
                        }}
                        onClick={switchLangue}
                    >
                        {langue === 'fr' &&
                            <>À Madagascar, la cithare sur caisse marovany est utilisée dans les rituels de transe. Cette vidéo de
                                2000 montre l'interaction entre l'officiante en rouge, qui va tomber en transe, et le cithariste
                                Velonjoro.</>
                        }
                        {langue === 'en' &&
                            <>In Madagascar, the marovany zither is used in trance rituals. This video from 2000 shows the
                                interaction between the officiant in red, who is about to fall into a trance, and the zitherist
                                Velonjoro.</>
                        }
                    </div>

                    <div
                        style={{
                            position: 'absolute',
                            top: '470px',
                            left: '580px',
                            width: '80px',
                            height: '30px',
                            cursor: 'pointer',
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/menu.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '0px',
                            }}
                            onMouseEnter={() => { setShowMenu(true) }}
                            onMouseLeave={() => { setShowMenu(false) }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/droite.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '30px',
                            }}
                            onClick={() => {
                                //navigate(process.env.PUBLIC_URL + '/madagascar/2-sensors/');
                                handleMenuClick(2);
                                setPage(2);
                            }}
                        />
                    </div>
                </>
            }
            {/* page 2 */}
            {page === 2 &&
                <>
                    <video
                        style={{
                            position: 'absolute',
                            top: '15px',
                            left: '150px',
                            height: '220px',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/movies/mad22.mp4'}
                        controls
                    />
                    <video
                        style={{
                            position: 'absolute',
                            top: '250px',
                            left: '50px',
                            width: '570px',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/movies/mad21.mp4'}
                        controls
                    />
                    <div
                        className='text'
                        style={{
                            position: 'absolute',
                            top: '420px',
                            width: '614px',
                            left: '20px',
                            color: 'white',
                            fontSize: '16px',
                            fontFamily: 'Futura',
                            cursor: 'pointer',
                        }}
                        onClick={switchLangue}
                    >
                        {langue === 'en' &&
                            <>Thanks to piezo microphones placed on the bridges, Olivier Adam's team at LAM succeeded in
                                transcribing Velonjoro's playing into MIDI in 2014.</> //PB40
                        }
                        {langue === 'fr' &&
                            <>Grâce aux micros piezo placés sur les chevalets, l'équipe d'Olivier Adam au LAM a réussi en 2014
                                à transcrire en MIDI le jeu de Velonjoro.</>
                        }
                    </div>

                    <div
                        style={{
                            position: 'absolute',
                            top: '470px',
                            left: '550px',
                            width: '110px',
                            height: '30px',
                            cursor: 'pointer',
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/gauche.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '0px',
                            }}
                            onClick={() => {
                                handleMenuClick(1);
                                //navigate(process.env.PUBLIC_URL + '/madagascar//');
                                setPage(1);
                            }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/menu.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '30px',
                            }}
                            onMouseEnter={() => { setShowMenu(true) }}
                            onMouseLeave={() => { setShowMenu(false) }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/droite.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '60px',
                            }}
                            onClick={() => {
                                handleMenuClick(3);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/3-rattle/');
                                setPage(3);
                            }}
                        />
                    </div>
                </>
            }
            {/* page 3 */}
            {page === 3 &&
                <>
                    <img
                        style={{
                            position: 'absolute',
                            top: '5px',
                            left: '110px',
                            width: '440px',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/images/madagascar/hochet.png'}
                    />
                    <video
                        style={{
                            position: 'absolute',
                            top: '245px',
                            left: '10px',
                            width: '640px',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/movies/mad32.mp4'}
                        controls
                    />
                    <video
                        style={{
                            position: 'absolute',
                            top: '335px',
                            left: '10px',
                            width: '640px',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/movies/mad31.mp4'}
                        controls
                    />
                    <div
                        className='text'
                        style={{
                            position: 'absolute',
                            top: '425px',
                            width: '614px',
                            left: '20px',
                            color: 'white',
                            fontSize: '16px',
                            fontFamily: 'Futura',
                            cursor: 'pointer',
                        }}
                        onClick={switchLangue}
                    >
                        {langue === 'en' &&
                            <>The citharist plays while listening through headphones to a rattle that gives the pulse. The pulse
                                does NOT fall on the accents of the rattle, but just before. Try beating the pulse (BPM=202)...!</>
                        }
                        {langue === 'fr' &&
                            <>Le cithariste joue en écoutant au casque un hochet qui donne la pulsation. La pulsation ne tombe
                                PAS sur les accents du hochet, mais juste avant. Essayez de battre la pulsation (BPM=202)...!</>
                        }
                    </div>

                    <div
                        style={{
                            position: 'absolute',
                            top: '470px',
                            left: '550px',
                            width: '110px',
                            height: '30px',
                            cursor: 'pointer',
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/gauche.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '0px',
                            }}
                            onClick={() => {
                                handleMenuClick(2);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/2-sensors/');
                                setPage(2);
                            }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/menu.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '30px',
                            }}
                            onMouseEnter={() => { setShowMenu(true) }}
                            onMouseLeave={() => { setShowMenu(false) }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/droite.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '60px',
                            }}
                            onClick={() => {
                                handleMenuClick(4);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/4-slowdown/');
                                setPage(4);
                            }}
                        />
                    </div>
                </>
            }
            {/* page 4 */}
            {page === 4 &&
                <>
                    <video
                        style={{
                            position: 'absolute',
                            top: '30px',
                            left: '90px',
                            width: '480px',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/movies/mad4.mp4'}
                        controls
                    />
                    <div
                        className='text'
                        style={{
                            position: 'absolute',
                            top: '420px',
                            width: '614px',
                            left: '20px',
                            color: 'white',
                            fontSize: '16px',
                            fontFamily: 'Futura',
                            cursor: 'pointer',
                        }}
                        onClick={switchLangue}
                    >
                        {langue === 'en' &&
                            <>Slow motion showing the delay between the accents of the rattle and the pulsation of the hand
                                clapping.</>
                        }
                        {langue === 'fr' &&
                            <>Ralenti montrant le décalage entre les accents du hochet et la pulsation marquée par les frappements
                                de main.</>
                        }
                    </div>

                    <div
                        style={{
                            position: 'absolute',
                            top: '470px',
                            left: '550px',
                            width: '110px',
                            height: '30px',
                            cursor: 'pointer',
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/gauche.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '0px',
                            }}
                            onClick={() => {
                                handleMenuClick(3);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/3-rattle/');
                                setPage(3);
                            }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/menu.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '30px',
                            }}
                            onMouseEnter={() => { setShowMenu(true) }}
                            onMouseLeave={() => { setShowMenu(false) }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/droite.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '60px',
                            }}
                            onClick={() => {
                                handleMenuClick(5);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/5-variation/');
                                setPage(5);
                            }}
                        />
                    </div>
                </>
            }
            {/* page 5 */}
            {page === 5 &&
                <>
                    <video
                        style={{
                            position: 'absolute',
                            top: '100px',
                            left: '10px',
                            width: '640px',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/movies/mad5.mp4'}
                        controls
                    />
                    <div
                        className='text'
                        style={{
                            position: 'absolute',
                            top: '410px',
                            width: '614px',
                            left: '20px',
                            color: 'white',
                            fontSize: '16px',
                            fontFamily: 'Futura',
                            cursor: 'pointer',
                        }}
                        onClick={switchLangue}
                    >
                        {langue === 'en' &&
                            <>Velonjoro's playing alternates between repetitive formulas and freer breaks.</>
                        }
                        {langue === 'fr' &&
                            <>Le jeu de Velonjoro alterne des formules répétitives et des sortes de breaks plus libres.</>
                        }
                    </div>

                    <div
                        style={{
                            position: 'absolute',
                            top: '470px',
                            left: '550px',
                            width: '110px',
                            height: '30px',
                            cursor: 'pointer',
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/gauche.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '0px',
                            }}
                            onClick={() => {
                                handleMenuClick(4);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/4-slowdown/');
                                setPage(4);
                            }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/menu.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '30px',
                            }}
                            onMouseEnter={() => { setShowMenu(true) }}
                            onMouseLeave={() => { setShowMenu(false) }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/droite.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '60px',
                            }}
                            onClick={() => {
                                handleMenuClick(6);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/6-duo/');
                                setPage(6);
                            }}
                        />
                    </div>
                </>
            }
            {/* page 6 */}
            {page === 6 &&
                <>
                    <video
                        style={{
                            position: 'absolute',
                            top: '35px',
                            left: '10px',
                            width: '640px',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/movies/mad6.mp4'}
                        controls
                    />
                    <div
                        className='text'
                        style={{
                            position: 'absolute',
                            top: '410px',
                            width: '614px',
                            left: '20px',
                            color: 'white',
                            fontSize: '16px',
                            fontFamily: 'Futura',
                            cursor: 'pointer',
                        }}
                        onClick={switchLangue}
                    >
                        {langue === 'en' &&
                            <>Djazz software designed at CAMS and IRCAM captures a musician and improvises by recombining
                                what it has captured. In 2014, it was trained by Marc Chemillier with Velonjoro's data, to play in
                                duo with him.</>
                        }
                        {langue === 'fr' &&
                            <>Le logiciel Djazz conçu au CAMS et à l'IRCAM capte un musicien et improvise en recombinant ce
                                qu'il a capté. En 2014, il a été entraîné par Marc Chemillier avec les données de Velonjoro, pour
                                jouer en duo avec lui.</>
                        }
                    </div>

                    <div
                        style={{
                            position: 'absolute',
                            top: '470px',
                            left: '550px',
                            width: '110px',
                            height: '30px',
                            cursor: 'pointer',
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/gauche.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '0px',
                            }}
                            onClick={() => {
                                handleMenuClick(5);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/5-variation/');
                                setPage(5);
                            }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/menu.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '30px',
                            }}
                            onMouseEnter={() => { setShowMenu(true) }}
                            onMouseLeave={() => { setShowMenu(false) }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/droite.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '60px',
                            }}
                            onClick={() => {
                                handleMenuClick(7);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/7-photo/');
                                setPage(7);
                            }}
                        />
                    </div>
                </>
            }
            {/* page 7 */}
            {page === 7 &&
                <>
                    <img
                        style={{
                            position: 'absolute',
                            top: '30px',
                            left: '10px',
                            width: '640px',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/images/madagascar/velonjoro.png'}
                    />
                    <div
                        className='text'
                        style={{
                            position: 'absolute',
                            top: '410px',
                            width: '614px',
                            left: '20px',
                            color: 'white',
                            fontSize: '16px',
                            fontFamily: 'Futura',
                            cursor: 'pointer',
                        }}
                        onClick={switchLangue}
                    >
                        {langue === 'en' &&
                            <>Velonjoro passed away on January 10, 2017, but his data lives on. In 2022, the world-famous
                                Malagasy citharist Justin Vali listened to Velonjoro's data and was inspired to play with him.</>
                        }
                        {langue === 'fr' &&
                            <>Velonjoro est décédé le 10 janvier 2017, mais ses données sont toujours là. En 2022, le grand
                                cithariste malgache Justin Vali mondialement connu a écouté les données de Velonjoro et il a eu
                                envie de jouer avec lui.</>
                        }
                    </div>

                    <div
                        style={{
                            position: 'absolute',
                            top: '470px',
                            left: '550px',
                            width: '110px',
                            height: '30px',
                            cursor: 'pointer',
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/gauche.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '0px',
                            }}
                            onClick={() => {
                                handleMenuClick(6);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/6-duo/');
                                setPage(6);
                            }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/menu.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '30px',
                            }}
                            onMouseEnter={() => { setShowMenu(true) }}
                            onMouseLeave={() => { setShowMenu(false) }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/droite.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '60px',
                            }}
                            onClick={() => {
                                handleMenuClick(8);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/8-justinvali/');
                                setPage(8);
                            }}
                        />
                    </div>
                </>
            }
            {/* page 8 */}
            {page === 8 &&
                <>
                    <video
                        style={{
                            position: 'absolute',
                            top: '35px',
                            left: '10px',
                            width: '640px',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/movies/mad8.mp4'}
                        controls
                    />
                    <div
                        className='text'
                        style={{
                            position: 'absolute',
                            top: '430px',
                            width: '614px',
                            left: '20px',
                            color: 'white',
                            fontSize: '16px',
                            fontFamily: 'Futura',
                            cursor: 'pointer',
                        }}
                        onClick={switchLangue}
                    >
                        {langue === 'en' &&
                            <>Justin Vali's posthumous duet with Velonjoro, produced using Djazz software piloted by Marc
                                Chemillier.</>
                        }
                        {langue === 'fr' &&
                            <>Duo posthume de Justin Vali avec Velonjoro réalisé grâce au logiciel Djazz piloté par Marc
                                Chemillier.</>
                        }
                    </div>

                    <div
                        style={{
                            position: 'absolute',
                            top: '470px',
                            left: '550px',
                            width: '110px',
                            height: '30px',
                            cursor: 'pointer',
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/gauche.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '0px',
                            }}
                            onClick={() => {
                                handleMenuClick(7);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/7-photo/');
                                setPage(7);
                            }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/menu.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '30px',
                            }}
                            onMouseEnter={() => { setShowMenu(true) }}
                            onMouseLeave={() => { setShowMenu(false) }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/droite.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '60px',
                            }}
                            onClick={() => {
                                handleMenuClick(9);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/9-comment/');
                                setPage(9);
                            }}
                        />
                    </div>
                </>
            }
            {/* page 9 */}
            {page === 9 &&
                <>
                    <video
                        id="videoWithSubtitles"
                        style={{
                            position: 'absolute',
                            top: '35px',
                            left: '10px',
                            width: '640px',
                        }}
                        src={process.env.PUBLIC_URL + '/assets/movies/mad9.mp4'}
                        controls
                    />
                    <div
                        className='text'
                        style={{
                            position: 'absolute',
                            top: '457px',
                            width: '514px',
                            left: '20px',
                            color: 'white',
                            fontSize: '16px',
                            fontFamily: 'Futura',
                            cursor: 'pointer',
                            //display: document.getElementById('videoWithSubtitles') != null ? (document.getElementById('videoWithSubtitles').paused ? 'block' : 'none') : 'none',
                        }}
                        onClick={switchLangue}
                    >
                        {langue === 'en' &&
                            <>Justin Vali's comment on Velonjoro's very fast playing.</>
                        }
                        {langue === 'fr' &&
                            <>Commentaire de Justin Vali à propos du jeu très rapide de Velonjoro.</>
                        }
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            width: '600px',
                            top: '405px',
                            left: '30px',
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <div
                            className='text'
                            style={{
                                position: 'absolute',
                                top: '0px',
                                left: '0px',
                                color: 'white',
                                fontSize: '16px',
                                fontFamily: 'Futura',
                                cursor: 'pointer',
                                //backgroundColor: 'rgba(0,0,0,0.5)',
                                padding: '10px',
                                textAlign: 'center',
                                width: '100%',
                            }}
                            onClick={switchLangue}
                        >
                            {currentSubtitle}
                        </div>
                    </div>
                    <div
                        style={{
                            position: 'absolute',
                            top: '470px',
                            left: '550px',
                            width: '110px',
                            height: '30px',
                            cursor: 'pointer',
                        }}
                    >
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/gauche.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '0px',
                            }}
                            onClick={() => {
                                handleMenuClick(8);
                                //navigate(process.env.PUBLIC_URL + '/madagascar/8-justinvali/');
                                setPage(8);
                            }}
                        />
                        <img
                            src={process.env.PUBLIC_URL + '/assets/images/madagascar/menu.png'}
                            style={{
                                position: 'absolute',
                                width: '20px',
                                left: '30px',
                            }}
                            onMouseEnter={() => { setShowMenu(true) }}
                            onMouseLeave={() => { setShowMenu(false) }}
                        />
                    </div>
                </>
            }
            
            <div
                className="menu"
                style={{
                    position: 'absolute',
                    top: '280px',
                    left: '510px',
                    cursor: 'pointer',
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    color: 'white',
                    fontFamily: 'Futura',
                    display: showMenu ? 'block' : 'none',
                }}
                onMouseEnter={() => setShowMenu(true)}
                onMouseLeave={() => setShowMenu(false)}
            >
                <ul
                    style={{
                        listStyleType: 'none',
                        margin: 0,
                        padding: 10,
                    }}
                >
                    <li onClick={() => handleMenuClick(1)}>trance</li>
                    <li onClick={() => handleMenuClick(2)}>sensors</li>
                    <li onClick={() => handleMenuClick(3)}>rattle</li>
                    <li onClick={() => handleMenuClick(4)}>slowdown</li>
                    <li onClick={() => handleMenuClick(5)}>variation</li>
                    <li onClick={() => handleMenuClick(6)}>duo</li>
                    <li onClick={() => handleMenuClick(7)}>photo</li>
                    <li onClick={() => handleMenuClick(8)}>Justin Vali</li>
                    <li onClick={() => handleMenuClick(9)}>comment</li>
                </ul>
            </div>
        </>
    );
}

export default Madagascar;